import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({

    state: {
        token: sessionStorage.getItem('token') || '',
        login: false,
        role: "",
        linkmode: false,
        linkOBJECTID: '',
        linkOBJECT2ID: '',
        linkOBJECTTYPE: '',
        linkOBJECT2TYPE: '',
        linkDESCRIPTION: '',
        countries: '',
        province: '',
        isCrad: false,
        isViewer: false,
        isLoading: false,
        tfa : false,
        refreshToken: '',
        profile : false
    },
    mutations: {
        login(state, value) {
            state.login = value
        },
        profile(state, value) {
            state.profile = value
        },
        addtoken(state, token) {
            state.token = token
            state.login = true
        },
        addrole(state, role) {
            state.role = role
        },
        removetoken(state) {
            state.token = ""
            state.role = ""
            state.login = false
            state.tfa = false
            state.psk = ""
            state.haspsk = false
        },
        enablelinkMode(state, { id, type, description }) {

            state.linkDESCRIPTION = description
            state.linkOBJECTID = id
            state.linkOBJECTTYPE = type
            state.linkmode = true
        },
        disablelinkMode(state) {
            state.linkDESCRIPTION = ''
            state.linkOBJECTID = ''
            state.linkOBJECTTYPE = ''
            state.linkmode = false
            state.linkOBJECT2ID = ''
            state.linkOBJECT2TYPE = ''
        },
        addobject2Link(state, { id, type }) {
            state.linkOBJECT2ID = id
            state.linkOBJECT2TYPE = type
        },
        addcountry(state, country) {
            state.countries = country

        },
        addprovince(state, provinces) {
            state.province = provinces
        },
        cradLog(state, value) {
            state.isCrad = value
        },
        viewerLog(state, value) {
            state.isViewer = value
        },
        showLoading(state, value) {
            state.isLoading = value
        },
        tfapassed(state, value){
            state.tfa = value
        },
        addrefreshtoken(state, value){
            state.refreshToken = value
        }
    },
    actions: {
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout')
                localStorage.clear();
                sessionStorage.clear();
                //localStorage.removeItem('token')
                //var eachitem
                //var eachkey

                //for (var i = 0; i < localStorage.length; i++) {
                //    eachitem = localStorage.getItem(localStorage.key(i))
                //    eachkey = localStorage.key(i)
                    
                //    if (eachitem.includes("expiry")) {
                //        let personal = JSON.parse(localStorage.getItem(eachkey))
                //        if (personal.personal) {
                //            localStorage.removeItem(eachkey)
                //        }
                //    }
                //}
                resolve()
            })
        },
    },
    getters: {
        token: state => state.token,
        login: state => state.login,
        profile: state => state.profile,
        role: state => state.role,
        psk: state => state.psk,
        tfa: state => state.tfa,
        haspsk: state => state.haspsk,
        uri: state => state.otpauthURI,
        OBJECT1ID: state => state.linkOBJECTID,
        OBJECTTYPE: state => state.linkOBJECTTYPE,
        OBJECTDESCRIPTION: state => state.linkDESCRIPTION,
        OBJECT2ID: state => state.linkOBJECT2ID,
        OBJECT2TYPE: state => state.linkOBJECT2TYPE,
        LINKMODE: state => state.linkmode,
        COUNTRY: state => state.countries,
        PROVINCE: state => state.province,
        CRAD: state => state.isCrad,
        VIEWER: state => state.isViewer,
        LOADING: state => state.isLoading,
        twofactauth: state => state.tfa,
        refreshtoken : state => state.refreshToken
    }
})
